import produce from 'immer';

import {
	CheckoutOrderFragment,
	ExchangeOrderFragment,
	GdsServicesRefundOrderFragment,
	RefundOrderFragment
} from '@websky/graphql';
import {
	setOrder,
	setLastExchange,
	clearLastExchange,
	ActionTypes,
	setLastRefund,
	setLastGdsServicesRefund
} from './actions';

const initialState: CheckoutOrderFragment = null;

export const orderReducer = (state = initialState, { type, payload }: ActionTypes) => {
	return produce(state, draft => {
		switch (type) {
			case setOrder.toString():
				return payload;
			case setLastRefund.toString():
				const lastRefundActionPayload = payload as RefundOrderFragment;

				draft.exareInfo.lastRefund = lastRefundActionPayload;
				break;
			case setLastGdsServicesRefund.toString():
				const lastGdsServicesRefundActionPayload = payload as GdsServicesRefundOrderFragment;

				draft.exareInfo.lastGdsServicesRefund = lastGdsServicesRefundActionPayload;
				break;
			case setLastExchange.toString():
				const lastExchangeActionPayload = payload as ExchangeOrderFragment;

				draft.exareInfo.lastExchange = lastExchangeActionPayload;
				break;
			case clearLastExchange.toString():
				draft.exareInfo.lastExchange = null;
				break;
		}
	});
};
